import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  fetchGetQuery,
  fetchPutQuery,
  fetchPostQuery,
  fetchDeleteQuery,
} from "../api";

//GET data for only partner UM
export function useGetNacrtovaneVrednostiProjekta(id) {
  const url = `Projekti/${id}/finance/nacrtovano/umV2`;
  return useQuery({
    queryKey: ["nacrtovane-vrednosti-projekta", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//GET data for Nacrtovane vrednosti projekta clanice
export function useGetNacrtovaneVrednostiProjektaClanice(id) {
  const url = `Projekti/${id}/finance/nacrtovano/claniceV2`;
  return useQuery({
    queryKey: ["nacrtovane-vrednosti-projekta-clanice", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//GET data for Realizirane vrednosti projekta (UM)
export function useGetRealiziraneVrednostiProjekta(id) {
  const url = `Projekti/${id}/finance/realizirano/umV2`;
  return useQuery({
    queryKey: ["realizirane-vrednosti-projekta", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//GET data for Realizirane vrednosti projekta clanice
export function useGetRealiziraneVrednostiProjektaClanice(id) {
  const url = `Projekti/${id}/finance/realizirano/claniceV2`;
  return useQuery({
    queryKey: ["realizirane-vrednosti-projekta-clanice", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//GET stroskovna-mestaV2 za clanice
export function useGetStroskovnaMestaClanice(id) {
  const url = `Projekti/${id}/stroskovna-mestaV2`;
  return useQuery({
    queryKey: ["stroskovna-mesta-clanice", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//GET data for De minimis by projekt ID
export function useGetDeminimisByProjekt(id) {
  const url = `deminimis-pomoc/by-projekt/${id}`;
  return useQuery({
    queryKey: ["deminimis-by-projekt", id],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
  });
}

//PUT API call for editing Nacrtovane vrednosti projekta (UM)
export function useEditNacrtovaneVrednostiProjekta(id) {
  const url = `Projekti/${id}/finance/nacrtovano/umV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch project splosno details after successful update
      queryClient.invalidateQueries({
        queryKey: ["nacrtovane-vrednosti-projekta", id],
      });
    },
  });
}

//PUT API call for editing vrednosti of clanice projekta (UM)  - Nacrtovane
export function useEditNacrtovaneVrednostiProjektaClanice(id) {
  const url = `Projekti/${id}/finance/nacrtovano/claniceV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch project splosno details after successful update
      queryClient.invalidateQueries({
        queryKey: ["nacrtovane-vrednosti-projekta-clanice", id],
      });
      queryClient.invalidateQueries({
        queryKey: ["nacrtovane-vrednosti-projekta", id],
      });
    },
  });
}

//PUT API call for editing realizirane vrednosti projekta (UM)
export function useEditRealiziraneVrednostiProjekta(id) {
  const url = `Projekti/${id}/finance/realizirano/umV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch project splosno details after successful update
      queryClient.invalidateQueries({
        queryKey: ["realizirane-vrednosti-projekta", id],
      });
    },
  });
}

//PUT API call for editing vrednosti of clanice projekta (UM)  - Realizirane
export function useEditRealiziraneVrednostiProjektaClanice(id) {
  const url = `Projekti/${id}/finance/realizirano/claniceV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch project splosno details after successful update
      queryClient.invalidateQueries({
        queryKey: ["realizirane-vrednosti-projekta-clanice", id],
      });
      queryClient.invalidateQueries({
        queryKey: ["realizirane-vrednosti-projekta", id],
      });
    },
  });
}

//POST API call for adding stroskovna mesta in stroskovni nosilec of clanice projekta
export function useAddStroskovnaMestaClanice(id) {
  const url = `Projekti/${id}/stroskovna-mestaV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPostQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch stroskovna mesta for clanice after successful update
      queryClient.invalidateQueries({
        queryKey: ["stroskovna-mesta-clanice", id],
      });
    },
  });
}

//PUT API call for editing stroskovna mesta in stroskovni nosilec of clanice projekta
export function useEditStroskovnaMestaClanice(id) {
  const url = `Projekti/${id}/stroskovna-mestaV2`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      return fetchPutQuery(url, payload);
    },
    onSuccess: () => {
      // Invalidate and refetch stroskovna mesta for clanice after successful update
      queryClient.invalidateQueries({
        queryKey: ["stroskovna-mesta-clanice", id],
      });
    },
  });
}

//DELETE API call for deleting stroskovno mesto of clanice projekta
export function useDeleteStroskovnaMestaClanice(idProject, idStroskovnoMesto) {
  const url = `Projekti/${idProject}/stroskovna-mestaV2/${idStroskovnoMesto}`;

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return fetchDeleteQuery(url);
    },
    onSuccess: () => {
      // Invalidate and refetch stroskovna mesta for clanice after successful delete
      queryClient.invalidateQueries({
        queryKey: ["stroskovna-mesta-clanice", idProject],
      });
    },
  });
}
